// Estados de una Guia de Salida (mismo flujo que Parte de Produccion)
export type EstadoType = 'PEN' | 'APR' | 'ANU';

// Tipo de salida del producto
export type TipoSalida = 'FRESCO' | 'CONGELADO';

// Origen del item liberado
export type OrigenSalida = 'PRODUCTO_B' | 'DEV_INTERNA';

export interface ClienteRef {
  idPersona: number;
  razonSocial?: string;
}

export interface GuiaSalidaDetalle {
  id: number;
  idGuiaSalida: number;
  idGuiaProduccionDetalle: number;
  origen: OrigenSalida;
  kilos: number;
  cantidad: number;

  // Datos opcionales hidratados desde la navegacion del backend
  guiaProduccionDetalle?: {
    id: number;
    idGuiaProduccion: number;
    idArticulo: number;
    cantidad: number;
    articulo?: {
      idArticulo: number;
      codigoArticulo?: string;
      descripcion?: string;
      pesoEmpaqueInterior?: number;
      presentacion?: { idPresentacion: number; descripcion: string };
      calibre?: { idCalibre: number; descripcion: string };
    };
    guiaProduccion?: {
      id: number;
      guiaRecepcion?: {
        documento?: { id: number; numeroDocumento?: string };
      };
    };
  };
}

export interface GuiaSalida {
  id: number;
  numero: string;
  fechaSalida: string;
  idCliente?: number | null;
  tipoSalida: TipoSalida;
  placaVehiculo?: string | null;
  estado: EstadoType;
  observaciones?: string | null;
  fechaCreacion: string;
  idUsuarioCreacion?: number | null;
  idUsuarioAprueba?: number | null;
  fechaAprobacion?: string | null;
  idUsuarioAnula?: number | null;
  fechaAnulacion?: string | null;

  cliente?: ClienteRef | null;
  detalles: GuiaSalidaDetalle[];
}

export interface StockDisponibleItem {
  idGuiaProduccionDetalle: number;
  origen: OrigenSalida;
  idGuiaProduccion: number;
  numeroGuiaProduccion: number;
  numeroDerc?: string | null;
  fechaExtraccion?: string | null;
  idArticulo: number;
  codigoArticulo?: string | null;
  descripcionArticulo?: string | null;
  presentacion?: string | null;
  calibre?: string | null;
  pesoEmpaqueInterior: number;
  cantidadDisponible: number;
  kilosDisponibles: number;
}

export interface GuiaSalidaDetalleRequest {
  id?: number;
  idGuiaProduccionDetalle: number;
  origen: OrigenSalida;
  kilos: number;
  cantidad: number;
}

export interface GuiaSalidaRequest {
  id?: number;
  fechaSalida: string;
  idCliente?: number | null;
  tipoSalida: TipoSalida;
  placaVehiculo?: string | null;
  observaciones?: string | null;
  detalles: GuiaSalidaDetalleRequest[];
}

export interface GuiaSalidaState {
  guias: GuiaSalida[];
  loading: boolean;
  error: string | null;
}

export const estadoLabels: Record<EstadoType, string> = {
  PEN: 'Pendiente',
  APR: 'Aprobado',
  ANU: 'Anulado',
};

export const estadoColors: Record<EstadoType, 'warning' | 'success' | 'error'> = {
  PEN: 'warning',
  APR: 'success',
  ANU: 'error',
};

export const tipoSalidaLabels: Record<TipoSalida, string> = {
  FRESCO: 'Fresco',
  CONGELADO: 'Congelado',
};

export const origenLabels: Record<OrigenSalida, string> = {
  PRODUCTO_B: 'Producto B',
  DEV_INTERNA: 'Dev. Interna',
};

export const origenColors: Record<OrigenSalida, 'info' | 'warning'> = {
  PRODUCTO_B: 'info',
  DEV_INTERNA: 'warning',
};
